import { generate, grey, gold } from '@ant-design/colors';
import { DefaultTheme } from 'styled-components';
import { getContrastingColor } from '@guuru/theme-common';

export default (primaryColor: string): DefaultTheme => {
  const primaryVariants = generate(primaryColor);
  const contrastColor = getContrastingColor(primaryVariants);

  return {
    primaryColor,
    primaryVariants,
    secondaryColor: primaryColor,
    secondaryVariants: primaryVariants,
    neutralVariants: grey,
    backgroundColor: '#ffffff',
    borderColor: 'rgba(5, 5, 5, 0.06)',
    surfaceColor: '#f0f0f0',
    secondarySurfaceColor: 'rgba(255, 255, 255, 0.8)',
    errorColor: '#ff4d4f',
    warningColor: '#faad14',
    successColor: '#52c41a',
    starColor: gold[5],
    onPrimaryColor: '#ffffff',
    onSecondaryColor: contrastColor,
    onLightColor: '#424245',
    onBackgroundColor: primaryVariants[5],
    onSurfaceColor: grey[8],
    onErrorColor: '#fff2f0',
    smallRadius: '5px',
    mediumRadius: '20px',
    shadow: 'none',
    disabledBackgroundColor: '#f5f5f5',
    disabledBorderColor: '#d9d9d9',
    disabledTextColor: 'rgba(0, 0, 0, 0.25)',
    guuruColor: '#00B0FF',
  };
};
